<div class="chat-container">
  <div class="chat-header">
    <div class="header-left">{{ data.message }} ({{ data.count }} ) ({{ phoneNumber }} )</div>
  
  </div>
  <div class="chat-body" #chatBody (scroll)="checkScrollPosition()">
    <div *ngFor="let c of conversations" class="chat-row" [class.ai]="c.is_ai" [class.user]="!c.is_ai">
      <!-- <div class="avatar">{{ !c.is_ai ? 'Me' : 'User' }}</div> -->
      <div class="bubble">
  <!-- Render everything as Markdown using ngx-markdown. If message is a JSON array, convert to markdown list. -->
  <markdown class="markdown-message" [data]="c.message"></markdown>
        <div class="meta">{{ formatDate(c.created_at) }}</div>
      </div>
    </div>
    <div class="loading-row" *ngIf="loading" style="text-align:center;padding:8px;">
      Loading...
    </div>
    <div class="no-more" *ngIf="!hasMore && !loading" style="text-align:center;padding:8px;color:var(--muted-color)">
      No more messages
    </div>
  </div>

  
</div>
